import styled from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";


export const StyledInput = styled.input`
    cursor: pointer;
`;

export const StyledInputContainer = styled.div`
    position: relative;

    ${StyledInput} {
        display: block;
        height: 40px;

        width: 100%;
        margin: 0;
        padding: 0 16px;
        line-height: 16px;
        ${setFontVariant("input2", colorsPalettes.carbon["400"])};
        border: 1px solid ${colorsPalettes.midnight["50"]};
        border-radius: 3px;
        box-shadow: none;
        cursor: text;

        &::placeholder {
            color: ${colorsPalettes.carbon["200"]};
        }

        &:focus {
            outline: none;
            box-shadow: 0 3px 5px 0 ${rgba(colorsPalettes.carbon[500], 0.12)};
            border-color: ${colorsPalettes.blue[400]};
        }
    }
`;

export const StyledInputLoader = styled.div`
    display: flex;
    margin: 0;
    padding: 12px;
    border: 1px solid ${colorsPalettes.midnight["50"]};
    border-radius: 3px;
`;
